module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-product3.230a6e35.png";